export default "__VITE_ASSET__CEFfOn9y__"